import * as React from "react";

import {
  Dialog,
  Slide,
  Grid,
  Typography,
  IconButton,
  makeStyles,
  Divider,
} from "@material-ui/core";
import Image from "next/image";
import CloseIcon from "@material-ui/icons/Close";

import RateImage from "../../../../../../../public/assets/images/comment-modal.png";
import RoundButton from "../../../../../../common/button/RoundButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      borderRadius: "21px !important",
    },
  },
  closeIcon: {
    fontSize: "1.818rem",
  },
  container: {
    width: "500px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  Typography1: {
    fontSize: "1.818rem",
    fontFamily: "Vazir-Bold",
  },
  header: {
    // backgroundColor: 'red',
  },
  padding: {
    padding: "20px 10px",
  },
  paddingLight: {
    padding: "10px 10px",
  },
  closeContainer: {
    textAlign: "right",
  },
  row: {
    backgroundColor: "#ffffff",
    "& *": {
      fontSize: "2.181rem",
    },
  },
  headerItems: {
    "& *": {
      fontFamily: "Vazir-Light",
      fontSize: "1.454rem",
      color: "#8898aa",
    },
  },
  alert: {
    marginBottom: "40px",
  },
  typoBody: {
    color: "#8898aa",
  },
  acceptBtn: {
    textAlign: "center",
    margin: "20px 0",
    fontFamily: "Vazir-Bold",
    fontSize: "1.272rem",
    padding: "8px 10px !important",
  },
  divider: {
    margin: "30px 0 0 0",
  },
  okT: {
    color: "#009693",
    fontSize: "2.909rem !important",
    fontWeight: "bold",
    fontFamily: "Vazir-Bold",
  },
}));
const CommentOKDialog = ({
  open,
  setOpen,
  title = "امتیاز شما ثبت شد",
  subtitle = "با ثبت نظر در موسسات دیگر به بهبود خدمات رسانی موسسات کمک کنید",
  setReadyToSend,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
    if (setReadyToSend) {
      setReadyToSend(false);
    }
  };

  const handleClick = () => {
    // salons/:id/comments
    setOpen(false);
    if (setReadyToSend) {
      setReadyToSend(true);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      scroll="paper"
      maxWidth="xl"
      onClose={handleClose}
      className={classes.root}
    >
      <Grid container className={classes.container}>
        <Grid item container xs={12} sm={12} md={12} justify="flex-start">
          <IconButton onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="center"
          justify="center"
          className={classes.alert}
        >
          <Image
            placeholder="blur"
            src={RateImage}
            alt="test"
            width={200}
            height={200}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="h4" align="center" className={classes.okT}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            variant="body1"
            align="center"
            className={classes.typoBody}
          >
            {subtitle}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.divider}>
          <Divider />
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="center"
          justify="center"
          className={classes.acceptBtn}
        >
          <Grid item xs={6} sm={6} md={4}>
            <RoundButton
              fullWidth
              bgColor="white"
              textColor="#009693"
              onClick={handleClick}
            >
              تایید
            </RoundButton>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CommentOKDialog;
